import React from "react";
import './styles/landing.css';

const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Tugas dan Fungsi Badan Mutu KKP</h2>
          <p className="lead">
            Badan Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan (BPPMHKP) atau yang dikenal sebagai Badan Mutu KKP, memiliki tugas utama untuk mengawasi dan mengendalikan mutu serta keamanan hasil kelautan dan perikanan. 
            Tugas-tugas ini meliputi penyusunan kebijakan, rencana, dan program terkait pengendalian dan pengawasan mutu dan keamanan hasil kelautan dan perikanan, serta pelaksanaan kegiatan tersebut. 
            Selain itu, BPPMHKP juga bertugas untuk memastikan keamanan dan mutu hasil perikanan.
          </p>
        </div>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5 g-4">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col">
                  <div className="service-item card h-100 border-0 shadow-sm position-relative">
                    <div className="services-box position-absolute top-0 start-50 translate-middle">
                      <img 
                      src={d.icon} 
                      alt={d.title} 
                      className="mb-3" 
                      style={{ objectFit: "contain",}} 
                    />
                    </div>
                    <div className="card-body p-4 pt-5 mt-3">
                      <h3 className="h6 fw-bold mb-3">{d.name}</h3>
                      <p className="card-text" style={{whiteSpace: 'pre-line'}}>{d.text}</p>
                    </div>
                  </div>
                </div>
              ))
            : <div className="col-12 text-center py-5">Loading...</div>}
        </div>
      </div>
    </div>
  );
};

export default Services;